<template>
    <v-row no-gutters>
        <template v-if="isAuthorized">
            <v-col cols="12" class="d-flex py-2 px-6">
                <!-- <v-toolbar dense> -->
                <v-switch
                    v-model="addEvenIfNone"
                    :label="'Tous les contrôles'"
                    style="text-center"
                />
                <v-switch
                    v-model="allCompanies"
                    :label="'Toutes les sociétés'"
                    style="text-center"
                    class="ml-2"
                    v-if="currentUser.allAvailableCompanies.length > 1"
                />
                <v-switch
                    v-model="isIgnored"
                    :label="'Filtrer les alertes ignorés'"
                    style="text-center"
                    class="ml-2"
                />
                <v-spacer />
                <v-btn-toggle
                    v-model="switchViewType"
                    group
                    mandatory
                    color="secondary"
                    v-if="!$vuetify.display.mobile"
                    density="compact"
                >
                    <v-btn data-cy="auditStatus-view-list" icon="$list" :value="0"> </v-btn>
                    <v-btn data-cy="auditStatus-view-grid" icon="$grid_view" :value="1"> </v-btn>
                </v-btn-toggle>
            </v-col>
            <!-- </v-toolbar> -->
            <v-col cols="12" :class="!$vuetify.display.mobile ? 'py-0' : 'px-2'">
                <!-- <v-list   v-if="1==0">
                    <v-skeleton-loader v-if="loading"
                        type="list-item-avatar-two-line"
                    ></v-skeleton-loader>
                    <v-list-item
                        v-else-if="checks.length"
                        v-for="(check, i) in checks"
                        :key="i"
                        :class="geTypeClass(check)"
                        @click.stop="openAction(check)"
                    >
                        <template
                        >
                        <v-progress-circular
                            rotate="270"
                            v-if="check.percentage !== undefined"
                            :value="check.percentage"
                            color="primary"
                            >
                            {{ check.percentage }}
                        </v-progress-circular>
                        <v-icon
                        v-else
                        :class="check.iconClass"
                        >{{check.icon}}</v-icon>
                        </template>

                            <v-list-item-title>
                                <v-avatar color="primary" size="24" class="mr-2">
                                <span class="white--text">{{check.count}}</span>
                                </v-avatar>{{check.title}}
                            </v-list-item-title>
                            <v-list-item-subtitle v-if="check.amountInfo">{{check.amountInfo}}</v-list-item-subtitle>
                        <v-list-item-check>
                            <v-layout wrap>
                                <v-flex>

                                </v-flex>
                                <v-flex>
                                    <v-btn icon>
                                        <v-icon color="primary">$chevron_right</v-icon>
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-list-item-check>
                    </v-list-item>
                    <v-list-item
                    v-else>
                    <template
                        >
                        <v-icon
                        class="primary white-text"
                        >$check</v-icon>
                        </template>

                        <v-list-item-title>Aucune check n'est requise pour le moment</v-list-item-title>
                        <v-list-item-check>
                        </v-list-item-check>
                    </v-list-item>
                </v-list>
                <template v-else>-->
                <v-timeline align-top dense v-if="viewType === 0">
                    <v-hover
                        v-slot:default="{ isHovering, props }"
                        v-for="(check, i) in checks"
                        :key="i"
                    >
                        <v-timeline-item
                            :color="checkColor(check)"
                            :icon="checkIcon(check)"
                            v-bind="props"
                        >
                            <!-- <v-row v-if="check.type === 'header'">
                            <v-col class="ml-2 px-0 text-left">-->
                            <div
                                class="headline font-weight-bold primary--text"
                                v-if="check.type === 'header'"
                            >
                                {{ $t("audit.scope." + check.scope + ".title") }}
                                <!-- {{ check.count + " " +check.title }} -->
                                <!-- {{ check.title }} -->
                            </div>
                            <!-- </v-col>
                            </v-row>-->
                            <v-row
                                justify="space-between"
                                :class="getTimeLineItemRowClass(check, isHovering)"
                                v-else
                            >
                                <v-col class="pr-0 text-left py-0">
                                    <div class="title" :style="titleColor(check)">
                                        <strong>{{ check.count }}</strong>
                                        <span>{{ " " + check.title }}</span>
                                    </div>
                                    <div v-if="check.amountInfo" class="overline mt-2">
                                        {{ check.amountInfo }}
                                    </div>
                                    <div
                                        class="text-left pb-0"
                                        v-else-if="check.check === 'CheckTax'"
                                    >
                                        {{ formatDate(check.dueDate) + " - " + check.text }}
                                    </div>
                                    <div v-else-if="check.addDescription" class="overline mt-2">
                                        {{ $t("audit." + check.check + ".description") }}
                                    </div>
                                    <div v-else-if="check.description" class="overline mt-2">
                                        {{ check.description }}
                                    </div>
                                </v-col>
                                <v-col cols="4" class="pl-2 pr-0 py-0">
                                    <div
                                        v-if="
                                            check.check === 'CheckDocSalesToReconciliate' &&
                                            check.followUpSales
                                        "
                                    >
                                        <bar-chart
                                            :data="check.followUpSales"
                                            :options="followUpSalesOptions"
                                            :height="80"
                                        />
                                    </div>
                                    <v-progress-linear
                                        rounded
                                        :height="25"
                                        v-else-if="check.percentage !== undefined"
                                        color="#5FC9B8"
                                        :model-value="check.percentage"
                                    >
                                        <strong class="white--text">{{ check.percentage }}%</strong>
                                    </v-progress-linear>
                                </v-col>
                                <v-col cols="1" class="text-center pl-2 py-0">
                                    <v-btn-icon
                                        icon="$remove_red_eye"
                                        color="secondary"
                                        v-if="check.show"
                                        @click.stop="showItems(check)"
                                        :data-cy="'auditStatus-show-' + check.check"
                                    />
                                    <v-btn-icon
                                        icon="$spellcheck"
                                        color="secondary"
                                        v-if="check.action"
                                        @click.stop="openAction(check)"
                                        :data-cy="'auditStatus-action-' + check.check"
                                    />
                                    <!-- <div><v-btn  size="small" rounded :outlined="isOutlined(document)" color="secondary">{{ callToActionText(document) }}</v-btn></div>
                                                <div
                                                v-if="document.scope === 'SALES_INVOICE' && diffDueDate(document) !== undefined"
                                                class="pt-2"
                                                :style="diffDueDate(document) < 0 ? 'color: red;':'color: #5FC9B8'"
                                    >{{dueDateStatus(document)}}</div>-->
                                </v-col>
                            </v-row>
                        </v-timeline-item>
                    </v-hover>
                </v-timeline>
                <v-expansion-panels
                    v-if="viewType === 1"
                    focusable
                    accordion
                    style="position: inherit"
                >
                    <v-expansion-panel
                        v-for="(type, cti) in typedChecks"
                        :key="cti"
                        style="background: transparent"
                    >
                        <v-expansion-panel-title class="primary--text">
                            <template v-slot:default="{ open }">
                                <v-row
                                    align="center"
                                    class="spacer"
                                    no-gutters
                                    :data-cy="'auditStatus-scope-' + type.scope"
                                >
                                    <!-- // // Justificatifs // -->
                                    <v-col>
                                        <strong>{{
                                            $t("audit.scope." + type.scope + ".title")
                                        }}</strong>
                                    </v-col>

                                    <!-- // // type.count // -->
                                    <v-col cols="1" class="text-center" v-if="!open">
                                        <span v-if="type.count" class="grey--text">
                                            ({{ type.count }})</span
                                        >
                                    </v-col>

                                    <!-- // // type.count // -->
                                    <v-col
                                        v-for="(status, si) in allStatus"
                                        :key="si"
                                        class="text-left"
                                    >
                                        <template v-if="!open">
                                            <v-icon :color="checkColor(type[status])">{{
                                                checkIcon(type[status])
                                            }}</v-icon>
                                            <span
                                                v-if="type[status] && type[status].count"
                                                class="grey--text"
                                            >
                                                ({{ type[status].count }})</span
                                            >
                                        </template>
                                    </v-col>
                                </v-row>
                            </template>
                        </v-expansion-panel-title>
                        <v-expansion-panel-text style="background: transparent">
                            <v-row no-gutters>
                                <!-- <v-flex xs12  sm12 md12 lg12 xl12 > -->
                                <v-col cols="4" v-for="(check, ci) in type.checks" :key="ci">
                                    <oss-mini-card
                                        :title="check.title"
                                        :count-title="check.count"
                                        :progress="
                                            !check.followUpSales ? check.percentage : undefined
                                        "
                                        :icon-btn1="check.show ? 'remove_red_eye' : null"
                                        :icon-btn2="check.action ? '$fa-spell-check' : null"
                                        :icon-notif="checkIcon(check)"
                                        :color-notif="checkColor(check)"
                                        :cy-prefix="'auditStatus-' + check.check"
                                        style="height: 100%, background: #FFF !important"
                                        @click:btn1="showItems(check)"
                                        @click:btn2="openAction(check)"
                                    >
                                        <v-row no-gutters>
                                            <v-col
                                                class="d-flex justify-center"
                                                style="min-height: 52px"
                                            >
                                                <template
                                                    v-if="check.check === 'CheckVATDeclaration'"
                                                >
                                                    <v-row no-gutters>
                                                        <v-col
                                                            cols="12"
                                                            v-if="check.amountInfo"
                                                            class="title mt-2 text-center"
                                                        >
                                                            {{ check.amountInfo }}
                                                        </v-col>
                                                        <v-col
                                                            cols="12"
                                                            v-if="check.vatDeclarationDateRange"
                                                            class="text-center"
                                                        >
                                                            A réaliser entre le
                                                            {{
                                                                formatDate(
                                                                    check.vatDeclarationDateRange
                                                                        .start,
                                                                ) +
                                                                " et le " +
                                                                formatDate(
                                                                    check.vatDeclarationDateRange
                                                                        .end,
                                                                )
                                                            }}
                                                        </v-col>
                                                    </v-row>
                                                </template>
                                                <template v-else-if="check.check === 'CheckTax'">
                                                    <v-row no-gutters>
                                                        <v-col
                                                            cols="12"
                                                            v-if="check.text"
                                                            class="title mt-2 text-center"
                                                        >
                                                            {{ check.text }}
                                                        </v-col>
                                                        <v-col
                                                            cols="12"
                                                            v-if="check.dueDate"
                                                            class="text-center"
                                                        >
                                                            A payer avant le
                                                            {{ formatDate(check.dueDate) }}
                                                        </v-col>
                                                    </v-row>
                                                </template>
                                                <template
                                                    v-else-if="
                                                        check.check ===
                                                        'CheckDocSalesToReconciliate'
                                                    "
                                                >
                                                    <v-row no-gutters>
                                                        <v-col
                                                            cols="12"
                                                            v-if="check.amountInfo"
                                                            class="title mt-2"
                                                            >{{ check.amountInfo }}
                                                        </v-col>
                                                        <v-col
                                                            cols="12"
                                                            class="text-center pb-0"
                                                            :style="
                                                                !$vuetify.display.mobile
                                                                    ? 'min-height: 60px;'
                                                                    : ''
                                                            "
                                                            v-if="check.followUpSales"
                                                        >
                                                            <bar-chart
                                                                :data="check.followUpSales"
                                                                :options="followUpSalesOptions"
                                                                :height="80"
                                                            />
                                                        </v-col>
                                                    </v-row>
                                                </template>

                                                <template v-else>
                                                    <div v-if="check.amountInfo" class="title mt-2">
                                                        {{ check.amountInfo }}
                                                    </div>
                                                    <div
                                                        v-else-if="check.addDescription"
                                                        class="title mt-2"
                                                    >
                                                        {{
                                                            $t(
                                                                "audit." +
                                                                    check.check +
                                                                    ".description",
                                                            )
                                                        }}
                                                    </div>
                                                    <div
                                                        v-else-if="check.description"
                                                        class="title mt-2"
                                                    >
                                                        {{ check.description }}
                                                    </div>
                                                </template>
                                            </v-col>
                                        </v-row>
                                    </oss-mini-card>
                                </v-col>
                            </v-row>
                        </v-expansion-panel-text>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
        </template>
    </v-row>
</template>

<script lang="ts">
import colors from "vuetify/lib/util/colors";
import { State2Way } from "@/decorators";
import moment from "moment-timezone";
import { Apollo } from "@/decorators";
import { User } from "../../store/store";
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";

import AUDIT_STATUS_QUERY from "../../graphql/audit/AuditStatus.gql";

import { chartColors } from "../../../../backend/src/common/chart/graphServices";

import { Bar as BarChart } from "vue-chartjs";
import { checkAccessRights } from "../../services/accessRightServices";
import { Component, Vue, toNative } from "vue-facing-decorator";

@Component({
    components: {
        BarChart,
    },
})
export class AuditStatus extends Vue {
    @State2Way("updateAuditFilterAddEvenIfNone", "auditFilter.addEvenIfNone")
    addEvenIfNone: boolean;

    @State2Way("updateAuditFilterAllCompanies", "auditFilter.allCompanies")
    allCompanies: boolean;

    @State2Way("updateAuditFilterIsIgnored", "auditFilter.isIgnored")
    isIgnored: boolean;

    // @State2Way("updateAccountingPeriods", "accountingPeriod.accountingPeriods")
    // accountingPeriods!: any

    // @State2Way("updateSelectedAccountingPeriod", "accountingPeriod.selectedAccountingPeriod")
    // accountingPeriod:any

    get companyId() {
        return this.$store.state.selected_company.id;
    }

    get accountingPeriodId() {
        return this.$store.state.accountingPeriod.selectedAccountingPeriod
            ? this.$store.state.accountingPeriod.selectedAccountingPeriod.id
            : undefined;
    }

    switchViewType: number = 1;

    get viewType() {
        if (this.$vuetify.display.mobile) return 1;
        return this.switchViewType;
    }

    set viewType(value) {
        this.switchViewType = value;
    }

    // "document": {
    //         "title":"Justificatif | Justificatifs"
    //     },
    //     "expenseReport": {
    //         "title":"Note de frais | Notes de frais"
    //     },
    //     "bankAccount": {
    //         "title":"Compte bancaire | Comptes bancaires"
    //     },
    //     "bankTransaction": {
    //         "title":"Mouvement bancaire | Mouvements bancaires"
    //     },
    //     "reconciliation": {
    //         "title":"Rapprochement | Rapprochements"
    //     },
    //     "vat": {
    //         "title":"TVA"
    //     },
    //     "miscelleanous": {
    //         "title":"Divers"
    //     },

    // iconTypes = {
    //     document: "$receipt",
    //     bankTransaction: "$fa-university",
    //     reconciliation: "$sync_alt"
    // }

    // colorTypes = {
    //     document: "secondary",
    //     invoice: "secondary",
    //     expenseReport: "primary",
    //     bankAccount: "primary",
    //     bankTransaction: "new_red",
    //     reconciliation: "new_red",
    //     vat: "new_red white--text",
    //     miscelleanous: "new_red",
    // };

    checkTypeIcons = {
        header: "category",
        INFORM: "$fa-check",
        ACTION: "notifications",
        WARNING: "notification_important",
        ERROR: "report_problem",
    };

    allStatus = ["ACTION", "WARNING", "ERROR", "INFORM"];

    checkTypeColors = {
        header: "blueGrey",
        INFORM: "green",
        ACTION: "blue",
        WARNING: "orange",
        ERROR: "red",
    };

    auditTypes = {
        document: 1,
        expenseReport: 2,
        invoice: 3,
        zTillReceipt: 4,
        bankAccount: 5,
        bankTransaction: 6,
        reconciliation: 7,
        vat: 8,
        tax: 9,
        miscelleanous: 10,
        accountingPeriodOpening: 11,
        accountingPeriodClosing: 12,
    };

    // dateFromNow(item) {
    //     if (item.date) return moment(item.date).fromNow();
    //     if (item.dueDate) return moment(item.dueDate).fromNow();
    //     return "";
    // }

    formatDate(date: string) {
        return moment(date).format("DD-MM-YYYY");
    }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    get loading() {
        if (this.$apollo.queries.checks) {
            return this.$apollo.queries.checks.loading;
        }
        return false;
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get isAuthorized() {
        const authorized = checkAccessRights(this.currentUser, "accounting", "audit");
        return authorized;
    }

    addTypeCheck(scope) {
        const typedChecks = {
            scope: scope,
            checks: [],
            count: 0,
        };
        for (const status of this.allStatus) {
            typedChecks[status] = {
                type: status,
                count: 0,
            };
        }
        return typedChecks;
    }

    addTypeChecks(typedChecks, check) {
        typedChecks.checks.push(check);
        typedChecks.count += check.count;
        if (!typedChecks[check.type]) {
            typedChecks[check.type] = {
                type: check.type,
                count: check.count,
            };
        } else {
            typedChecks[check.type].count += check.count;
        }
    }

    @Apollo({
        query: AUDIT_STATUS_QUERY,
        variables() {
            return {
                companyId: this.companyId,
                addEvenIfNone: this.addEvenIfNone,
                allCompanies: this.allCompanies,
                accountingPeriodId: this.accountingPeriodId,
                isIgnored: this.isIgnored,
            };
        },
        skip() {
            return !this.isAuthorized || this.companyId === null;
        },
        async specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.auditStatus && data.auditStatus.checks) {
                    this.checks = data.auditStatus.checks;
                    this.typedChecks = [];
                    if (this.checks.length) {
                        let auditTypeIndex = 100;
                        for (const check of this.checks) {
                            if (!check.scope) check.scope = "miscelleanous";
                            if (!this.auditTypes[check.scope]) {
                                // ////// NE PAS PUSHER //////
                                // // debugger;
                                // //////////////////
                                this.auditTypes[check.scope] = auditTypeIndex;
                                auditTypeIndex++;
                            }
                        }
                        this.checks.sort((a, b) => {
                            if (this.auditTypes[a.scope] < this.auditTypes[b.scope]) {
                                return -1;
                            }
                            if (this.auditTypes[a.scope] > this.auditTypes[b.scope]) {
                                return 1;
                            }
                            return 0;
                        });
                        let check = this.checks[this.checks.length - 1];
                        let prevScope = check.scope;
                        let counter = check.count;
                        let typedChecks = this.addTypeCheck(check.scope);
                        this.typedChecks.push(typedChecks);
                        this.addTypeChecks(typedChecks, check);

                        for (let i = this.checks.length - 2; i >= 0; i--) {
                            check = this.checks[i];
                            if (prevScope === check.scope) {
                                counter += check.count;
                            } else {
                                typedChecks = this.addTypeCheck(check.scope);
                                this.typedChecks.splice(0, 0, typedChecks);
                                this.checks.splice(i + 1, 0, {
                                    header: true,
                                    type: "header",
                                    count: counter,
                                    scope: prevScope,
                                    check: prevScope,
                                });
                                counter = check.count;
                            }
                            this.addTypeChecks(typedChecks, check);
                            prevScope = check.scope;
                        }
                        this.checks.splice(0, 0, {
                            header: true,
                            type: "header",
                            count: counter,
                            scope: prevScope,
                            check: prevScope,
                        });

                        for (check of this.checks) {
                            if (!check.title) {
                                check.title = this.$t(
                                    "audit." + check.check + ".title",
                                    check.count || 1,
                                );
                            }
                            // check.tagColor = this.colorTypes[check.scope];
                            if (check.amount) {
                                if (check.totalAmount) {
                                    check.amountInfo =
                                        "Soit " +
                                        newCommonFormatCurrency(check.amount) +
                                        " sur " +
                                        newCommonFormatCurrency(check.totalAmount);
                                } else if (check.check === "CheckVATDeclaration") {
                                    check.amountInfo = this.$t("audit." + check.check + ".amount", [
                                        newCommonFormatCurrency(check.amount),
                                    ]);
                                }
                            }
                            if (check.descriptionBTDiff) {
                                // @todo VINCENT factoriser et rendre générique à la description
                                const diff = check.diffCount;
                                check.title = "Écart Banque | Z de caisse";
                                if (diff < 0) {
                                    check.description =
                                        check.descriptionBTDiff +
                                        " ( " +
                                        newCommonFormatCurrency(-diff, { currency: "" }) +
                                        " )";
                                } else if (diff > 0) {
                                    check.description =
                                        check.descriptionBTDiff +
                                        " ( " +
                                        newCommonFormatCurrency(diff, { currency: "" }) +
                                        " )";
                                }
                            }
                            if (!check.type) {
                                check.type = "ACTION";
                            }
                            if (check.check === "CheckDocSalesToReconciliate") {
                                const now = moment();

                                const labels = [""];
                                const datasets = [];
                                if (check.paid && check.paid.amount) {
                                    datasets.push({
                                        label: "Réglés",
                                        barThickness: 25,
                                        data: [check.paid.amount],
                                    });
                                }
                                if (check.veryLate && check.veryLate.amount) {
                                    datasets.push({
                                        label: "Très en retard",
                                        barThickness: 25,
                                        data: [check.veryLate.amount],
                                    });
                                }
                                if (check.late && check.late.amount) {
                                    datasets.push({
                                        label: "En retard",
                                        barThickness: 25,
                                        data: [check.late.amount],
                                    });
                                }
                                if (check.afterNow && check.afterNow.amount) {
                                    datasets.push({
                                        label: "En attente",
                                        barThickness: 25,
                                        data: [check.afterNow.amount],
                                    });
                                }
                                if (datasets.length) {
                                    chartColors("bar", datasets, "cool");
                                    check.followUpSales = {
                                        labels: labels,
                                        datasets: datasets,
                                    };
                                }
                            }
                        }
                    }
                } else {
                    this.checks.splice(0, this.checks.length);
                }
            }
        },
    })
    checks: [] = [];

    typedChecks = [];

    get followUpSalesOptions() {
        return {
            plugins: {
                legend: { display: true, position: "bottom" },
                tooltip: {
                    mode: "point",
                },
            },
            scales: {
                y: {
                    stacked: true,
                    beginAtZero: true,
                    display: false,
                },
                x: {
                    stacked: true,
                    beginAtZero: true,
                    display: false,
                },
            },
            maintainAspectRatio: false,
        };
    }

    geTypeClass(check) {
        let typeClass = "mb-2 mx-2";
        if (this.$vuetify.display.mobile) {
            typeClass += " px-2";
        }
        typeClass += " listItem";
        return typeClass;
    }

    openAction(check) {
        if (check.action && check.action.pathName) {
            const location: any = {
                name: check.action.pathName,
            };
            if (check.action.params) {
                location.params = check.action.params;
            }

            this.$router.push(location);
        }
    }

    showItems(check) {
        if (check.show && check.show.pathName) {
            const location: any = {
                name: check.show.pathName,
            };
            if (check.show.params) {
                location.params = check.show.params;
            }
            this.$router.push(location);
        }
    }

    rowClass(check, hover) {
        let rowClass = "mt-4 auditCard";
        if (!this.$vuetify.display.mobile) {
            rowClass += " mr-4";
        }
        rowClass += hover ? " elevation-2" : " elevation-0";
        rowClass += check.count ? " auditCard-bct" : " auditCard-bcg";
        return rowClass;
    }

    getTimeLineItemRowClass(check, hover) {
        let rowClass = "mr-2 pa-2 auditCard-timeline";
        rowClass += hover ? " elevation-2" : " elevation-0";
        rowClass += check.count ? " auditCard-bct" : " auditCard-bcg";
        return rowClass;
    }

    checkColor(check) {
        if (check.count) {
            if (this.checkTypeColors[check.type]) {
                return this.checkTypeColors[check.type];
            }
            return "#5FC9B8";
        }
        return "#e0e0e0";
    }

    titleColor(check) {
        return `color: ${this.checkColor(check)};`;
    }

    firstColStyle(check) {
        return `background-color: ${this.checkColor(check)};`;
    }

    colorType() {
        return colors.blueGrey.lighten1;
    }

    headerBackgroundColor(check) {
        if (check.type === "header") {
            return `background-color: ${this.colorType()}!important;; border-radius: 12px !important;`;
        }
        // return `background-color: ${check.tagColor};`
        return "";
    }

    checkIcon(check) {
        return this.checkTypeIcons[check.type] || "notifications";
    }
}

export default toNative(AuditStatus);
</script>
<style lang="scss" scoped>
.listItem {
    background-color: white;
    border-radius: 6px;
}
.listItemSelected {
    background-color: #cbe2e1;
    border-radius: 6px;
}
.auditCard-timeline {
    border: solid 1px #f0f0f0;
}
.auditCard {
    border: solid 1px #e0e0e0;
    border-radius: 12px !important;
}
.auditCard-bct {
    background-color: white;
}

.auditCard-bcg {
    background-color: #f5f5f5;
}

.first-col {
    border-bottom-left-radius: 12px !important;
    border-top-left-radius: 12px !important;
}

.first-col-min-height {
    min-height: 165px;
    line-height: 165px;
}
.first-col-min-height-mobile {
    min-height: 130px;
    line-height: 130px;
}
</style>
